export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70d508a9f0316425c894cb47d8f6cf1f530d950ef2&name=pushAdClickData!'